import { Box, ButtonRow } from '@ksyos/design-system';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';
import { createServiceOptions } from '@frontend/components/pages/processStartWizard/components/serviceCards/createServiceOptions';
import { ServiceButton } from '@frontend/components/pages/processStartWizard/components/serviceCards/serviceButton';
import { ServiceCardContent } from '@frontend/components/pages/processStartWizard/components/serviceCards/ServiceCardContent';
import { ServiceTooltip } from '@frontend/components/pages/processStartWizard/components/serviceCards/serviceTooltip';
import { getServiceData } from '@frontend/components/pages/processStartWizard/data/getServiceData';

type ServiceCardWithStartButtonProps = {
    isSelected: boolean;
    onClickService: (service: ServiceForSelectedServiceType) => void;
    onClickSubService: (name: ServiceForSelectedServiceType['name'], service: ServiceForSelectedServiceType) => void;
    service: ServiceForSelectedServiceType;
};

export function ServiceCardWithStartButton({
    isSelected,
    service,
    onClickService,
    onClickSubService,
}: Readonly<ServiceCardWithStartButtonProps>) {
    const serviceData = getServiceData(service);
    const { buttonText, order } = serviceData;
    const { code, key, reason, services } = service;

    const serviceOptions = createServiceOptions(services, onClickSubService, service);

    return (
        <Box
            backgroundColor="white"
            borderRadius="base"
            boxShadow="base"
            key={key}
            order={order}
            p={6}
            pt={5}
            style={{ position: 'relative' }}
        >
            <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="space-between"
            >
                <ServiceCardContent data={serviceData} />

                <ButtonRow
                    justify="right"
                    sx={{ mt: 4 }}
                >
                    <ServiceButton
                        buttonText={buttonText}
                        isSelected={isSelected}
                        onClickService={onClickService}
                        service={service}
                        serviceOptions={serviceOptions}
                    >
                        <ServiceTooltip
                            reason={reason}
                            serviceCode={code}
                        />
                    </ServiceButton>
                </ButtonRow>
            </Box>
        </Box>
    );
}
